import React from 'react';
import goliveImage from '../../../assets/img/chatroom-imgs/golive.svg';
import interestedImage from '../../../assets/img/event-details-imgs/icon/interested-icon.svg';
import goingIcon from '../../../assets/img/event-details-imgs/icon/going-icon.svg'
const EventsFilterSection = () => {
    return (
        <div className="row mb-5 gap-3 gap-md-0">
            <div className="col-12 col-md-6">
                <button className="custm-pill-button-small d-flex justify-content-center align-items-center rounded-pill px-4 py-2 post_btn" type="button">
                    <img className="me-2" src={goliveImage} alt='' />
                        Join Online
                </button>
            </div>
            <div className="col-12 col-md-6 d-flex justify-content-start justify-content-md-end align-items-center gap-4">
                <div className="d-flex justify-content-center align-items-center px-4 py-2 rounded-pill filter-button-color">
                    <img className="me-2" src={interestedImage} alt='' />
                        <span className="center_txt">Interested</span>
                </div>
                <div className="d-flex justify-content-center align-items-center px-4 py-2 rounded-pill filter-button-color">
                    <img className="me-2" src={goingIcon} alt='' />
                        <span className="center_txt">Going</span>
                </div>
            </div>
        </div>
    );
};

export default EventsFilterSection;